import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';

@Api('api/app/ldap-server')
export class LdapServerDto extends DtoHasApi {
  id: number;
  name: string;
  enabled: boolean;
  ldapOverSsl: boolean;
  autoVerifyUsers: boolean;
  serverHost: string;
  port: number;
  bindUsername: string;
  password: string;
  ldapDomainName: string;
  skipCertificateValidation: boolean;
  certificateName: string;
}
